import styles from './styles/detailtable.module.css';

export default function Table({ table }) {
    if (table.length === 0) {
        return <div className={styles.error}>입력하신 내용을 이해할 수 없습니다. 다시 질문해 주세요.</div>;
    }

    if (table.length > 0) {
        return (
            <div className={styles.wrapper}>
                <table className={styles.table}>
                    <thead>
                    <tr>
                        {Object.keys(table[0]).map((key, index) => (
                            <th key={index}>{key}</th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {table.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {Object.values(row).map((value, colIndex) => (
                                <td key={colIndex}>{value}</td>
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }
}
